import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersEmployeeConditionSubmissionsSubmissionRepliesDestroyResponseType } from "~/domains";

type RequestDataType = {
  employeeConditionSubmissionId: string;
  id: string;
};

const request = ({ employeeConditionSubmissionId, id }: RequestDataType) => {
  return new ApiClient()
    .delete<ApiMembersEmployeeConditionSubmissionsSubmissionRepliesDestroyResponseType>(
      `/api/members/employee_condition_submissions/${employeeConditionSubmissionId}/submission_replies/${id}`,
    )
    .then((res) => res.data);
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApiMembersEmployeeConditionSubmissionsSubmissionRepliesDestroy =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ApiMembersEmployeeConditionSubmissionsSubmissionRepliesDestroyResponseType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
